module.exports = __webpack_public_path__ + "0c09a9d697b4e49084d3bbc69e229f0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/netflix_2022_chart.png
// module id = 1691
// module chunks = 0